var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:[
    'transform scale-100',
    'pointer-events-none',
    'fill-current',
    'fixed',
    _vm.color === _vm.OzBoxColors.Primary && {
      'text-white-100': _vm.darkMode === false,
      'text-nightfall-900': _vm.darkMode === true,
      'text-white-100 dark:text-nightfall-900': _vm.darkMode === 'auto',
    },
    _vm.color === _vm.OzBoxColors.Secondary && {
      'text-light-ui-200': _vm.darkMode === false,
      'text-dark-ui-200': _vm.darkMode === true,
      'text-light-ui-200 dark:text-dark-ui-200': _vm.darkMode === 'auto',
    },
    _vm.color === _vm.OzBoxColors.Selection && {
      'text-grape-500': _vm.darkMode === false,
      'text-canary-500': _vm.darkMode === true,
      'text-grape-500 dark:text-canary-500': _vm.darkMode === 'auto',
    },
    _vm.color === _vm.OzBoxColors.Highlight && {
      'text-canary-0': _vm.darkMode === false,
      'text-nightfall-800': _vm.darkMode === true,
      'text-canary-0 dark:text-nightfall-800': _vm.darkMode === 'auto',
    },
    _vm.color === _vm.OzBoxColors.Destructive && {
      'text-tangerine-0': _vm.darkMode === false,
      'text-nightfall-800': _vm.darkMode === true,
      'text-tangerine-0 dark:text-nightfall-800': _vm.darkMode === 'auto',
    },
    _vm.color === _vm.OzBoxColors.Pink && {
      'text-padlet-pink-0': _vm.darkMode === false,
      'text-nightfall-800': _vm.darkMode === true,
      'text-padlet-pink-0 dark:text-nightfall-800': _vm.darkMode === 'auto',
    },
    _vm.color === _vm.OzBoxColors.PrimaryBlur && {
      'text-light-ui-200': _vm.isFirefox && _vm.darkMode === false,
      'text-dark-ui-200': _vm.isFirefox && _vm.darkMode === true,
      'text-light-ui-200 dark:text-dark-ui-200': _vm.isFirefox && _vm.darkMode === 'auto',
      'text-common-ui-l86': !_vm.isFirefox && _vm.darkMode === false,
      'text-common-ui-d86': !_vm.isFirefox && _vm.darkMode === true,
      'text-common-ui-l86 dark:text-common-ui-d86': !_vm.isFirefox && _vm.darkMode === 'auto',
    } ],attrs:{"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"false"}},[_c('path',{attrs:{"classes":_vm.color === _vm.OzBoxColors.PrimaryBlur && ['backdrop-filter', 'backdrop-blur-10'],"d":"M0 0h24-.652a4 4 0 0 0-2.788 1.147l-5.717 5.62a4 4 0 0 1-5.608 0l-5.718-5.62A4 4 0 0 0 .73 0H0z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }